import {useState, useCallback, useRef} from "react";

export const useCaptcha = () => {
    const [captchaVisible, setCaptchaVisible] = useState(false);
    const [captchaKey, setCaptchaKey] = useState(1);
    const resolveCaptchaRef = useRef(null);
    const rejectCaptchaRef = useRef(null);
    const timeoutRef = useRef(null);

    const clearTimeoutRef = useCallback(() => {
        if (timeoutRef.current !== null) window.clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
    }, []);

    const failCaptcha = useCallback((message) => {
        clearTimeoutRef();
        setCaptchaVisible(false);
        setCaptchaKey((prev) => prev + 1);
        const reject = rejectCaptchaRef.current;
        rejectCaptchaRef.current = null;
        resolveCaptchaRef.current = null;
        if (reject) {
            const error = new Error(message);
            error.code = "CAPTCHA_UNAVAILABLE";
            reject(error);
        }
    }, [clearTimeoutRef]);

    const showCaptcha = useCallback(() => {
        return new Promise((resolve, reject) => {
            clearTimeoutRef();
            setCaptchaKey((prev) => prev + 1);
            setCaptchaVisible(true);
            resolveCaptchaRef.current = resolve;
            rejectCaptchaRef.current = reject;
            timeoutRef.current = window.setTimeout(() => {
                failCaptcha("Проверка не ответила. Попробуйте ещё раз.");
            }, 45000);
        });
    }, [clearTimeoutRef, failCaptcha]);

    const onCaptchaSuccess = useCallback((token) => {
        clearTimeoutRef();
        setCaptchaVisible(false);
        const resolve = resolveCaptchaRef.current;
        resolveCaptchaRef.current = null;
        rejectCaptchaRef.current = null;
        if (resolve) resolve(token);
    }, [clearTimeoutRef]);

    const onTokenExpired = useCallback(() => {
        failCaptcha("Время проверки истекло. Попробуйте ещё раз.");
    }, [failCaptcha]);

    const onNetworkError = useCallback(() => {
        failCaptcha("Проверка не загрузилась. Попробуйте ещё раз.");
    }, [failCaptcha]);

    const onJavascriptError = useCallback(() => {
        failCaptcha("Проверка недоступна. Попробуйте ещё раз.");
    }, [failCaptcha]);

    const resetCaptcha = useCallback(() => {
        failCaptcha("Проверка была закрыта. Попробуйте ещё раз.");
    }, [failCaptcha]);

    return {
        captchaVisible,
        captchaKey,
        showCaptcha,
        onCaptchaSuccess,
        onTokenExpired,
        onNetworkError,
        onJavascriptError,
        resetCaptcha,
    };
};
